<template>
  <div>
    <Topbar ref="topbar" />
    <div class="home-container">
      <div class="flex menu-list">
        <div class="item font-weight font-20" v-for="(item, index) in homeMenuList" :key="index"
          @click="handleMenu(item)">
          <div :style="{ color: activeMenu.code === item.code ? '#A40000' : '#000' }">{{ item.name }}</div>
          <i v-if="activeMenu.code === item.code" class="el-icon-caret-top icon"></i>
        </div>
      </div>
      <columnTitle :title="activeMenu.activeName" :icon="iconPush"></columnTitle>
      <cmsList v-if="activeMenu.code !== 'WZJJ'" :activeMenu="activeMenu" :data-list="cmsData" :dataTotal="dataTotal"
        :pageNo="this.searchInfo.pageNo" @handleMore="handleCmsMore" @update="handleCurrentChange"></cmsList>
      <introduce v-else></introduce>
      <columnTitle v-if="activeMenu.code == 'SYWZ'" :title="'考生入口'" :icon="iconInto"></columnTitle>
      <entrance v-if="activeMenu.code == 'SYWZ'"></entrance>
    </div>
    <Footer />
  </div>

</template>

<script>
// cpn
import columnTitle from "./components/columnTitle.vue";
import cmsList from "./components/cmsList.vue";
import introduce from "./components/introduce.vue";
import entrance from "./components/entrance.vue";
// image
import iconPush from "@/assets/image/home/iconPush.png"
import iconInto from "@/assets/image/home/iconInto.png"

// api 
import { getList } from '@/api/home/cmsIndex.js'

export default {
  name: "HomePage",
  components: {
    columnTitle,
    cmsList,
    introduce,
    entrance
  },
  data() {
    return {
      homeMenuList: [
        { name: '首页', code: 'SYWZ', activeName: '通知公告', value: '' },
        { name: '考试公告', code: 'KSGG', activeName: '考试公告', value: 'category_cms_exam' },
        { name: '成绩公示', code: 'CJGS', activeName: '成绩公示', value: 'category_cms_score' },
        { name: '市场简介', code: 'WZJJ', activeName: '云南省高校人才市场', value: '' },
      ],
      activeMenu: { name: '首页', code: 'SYWZ', activeName: '通知公告', value: '' },
      iconPush,
      iconInto,
      cmsData: [],
      dataTotal: 0,
      searchInfo: {
        pageNo: 1,
        pageSize: 10,
        category: ''
      }
    };
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    // menu 切换
    handleMenu(item) {
      this.activeMenu = item;
      this.searchInfo.pageNo = 1;
      this.getDataList()
    },
    // 首页更多
    handleCmsMore() {
      this.activeMenu = this.homeMenuList[1];
      this.searchInfo.pageNo = 1;
      this.getDataList()
    },
    // 获取数据
    async getDataList() {
      let params = {
        pageNo: 1,
        pageSize:10,
        category: this.activeMenu.value
      }
      const data = await getList(params);
      this.cmsData = data.list
      this.dataTotal = data.total
    },
    handleCurrentChange(val) {
      this.searchInfo.pageNo = val
      this.getDataList()
    },
  },
};
</script>

<style scoped lang="scss">
.home-container {
  width: 74%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 70px 0 50px;

  .menu-list {
    width: 100%;
    justify-content: space-around;
    padding: 0 20px;
    border-bottom: 1px solid #A40000;
    margin-bottom: 60px;

    .item {
      position: relative;
      padding-bottom: 20px;
      cursor: pointer;
      white-space: nowrap;
    }

    .icon {
      position: absolute;
      bottom: -9px;
      left: 50%;
      transform: translateX(-50%);
      color: #A40000;
      font-size: 26px;
    }
  }
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
  .home-container {
    width: 90%;
    padding: 40px 0 30px;

    .menu-list {
      padding: 0 10px;
      margin-bottom: 40px;

      .item {
        font-size: 18px;
        padding-bottom: 16px;
      }

      .icon {
        font-size: 22px;
        bottom: -7px;
      }
    }
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .home-container {
    width: 94%;
    padding: 30px 0 20px;

    .menu-list {
      height: 40px;
      padding: 0;
      margin-bottom: 30px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      justify-content: space-between;
      gap: 24px;

      &::-webkit-scrollbar {
        display: none;
      }

      .item {
        font-size: 16px;
        padding-bottom: 14px;
        flex-shrink: 0;
      }

      .icon {
        font-size: 20px;
        bottom: -7px;
      }
    }
  }
}
</style>
